import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Alert,
  Spinner,
} from "react-bootstrap";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory,Link } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
function AllPolyLines(props) {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [delStatus, setDelStatus] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [geoId, setGeoId] = useState("");
  const [vehicleData, setVehicleData] = useState([]);
  const [allPolyGon, setAllPolyGon] = useState([]);
  const [addVehicleArr, setAddVehicleArr] = useState("");
  var moverVehicle = [
    { name: "Bike" },
    { name: "3 Wheeler" },
    { name: "Tata Ace" },
    { name: "PickUp 8ft" },
    { name: "Tata 407" },
  ];
  var foodVehicle = [{ name: "Bike" }, { name: "Auto" }];
  var healthVehicle = [{ name: "Bike" }];
  var taxiVehicle = [
    { name: "Bike" },
    { name: "Auto" },
    { name: "Hatch Back" },
    { name: "Sedan" },
    { name: "SUV/MUV" },
  ];
  var airportVehicle = [
    { name: "Hatch Back" },
    { name: "Sedan" },
    { name: "SUV/MUV" },
  ];

  const handleClose = () => setShow(false);

  function getData() {
    axios
      .get(Baseurl.baseurl + `/health/get-all-geofence`)
      .then((res) => {
        if(res.data.status){
          setAllPolyGon(res.data.data);
          
        }
        setSpinner(false);
      })
      .catch((err) => {});
  }


  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  function addVehcileToGeoFence() {
    const artical = {
      vehicleName: vehicleData,
    };

    axios
      .put(`${Baseurl.baseurl}/health/add-vehicle-type/${geoId}`, artical)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => console.log(err));
    handleClose();
  }

  function deleteGeoFence() {
    axios
      .delete(`${Baseurl.baseurl}/health/delete-geofence/${geoId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
    handleClose();
  }
  const selection2 = (selectedValues) => {
    let vig = [];
    selectedValues.map((val) => {
      vig.push(val.name);
    });
    setVehicleData(vig);
  };
  function removeVehicleFromGeo(vehicle,gId){
    const artical = {
        vehicleName: vehicle,
      };
  
      axios
        .put(`${Baseurl.baseurl}/health/remove-vehicle-type/${gId}`, artical)
        .then((response) => {
          if (response.data.status) {
            swal("Removed", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            getData();
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => console.log(err));
  }
  return (
    <Col lg={12}>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {delStatus ? "Delete GeoFence" : "Add Vehicle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {delStatus ? (
            <h4>Are you sure you want to delete this geofence?</h4>
          ) : (
            <>
              <div>
                <label>
                  <strong>Vehicle Name</strong>
                </label>
                <Multiselect
                  closeIcon="close"
                  options={addVehicleArr}
                  displayValue="name"
                  onSelect={selection2}
                />
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {delStatus ? (
            <button
              className="btn btn-danger"
              onClick={() => {
                deleteGeoFence();
              }}
            >
              Delete
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addVehcileToGeoFence();
              }}
            >
              Add
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-sm">
                <thead>
                  <tr>
                    <th>
                      <strong className="text-sm">Name</strong>
                    </th>
                    <th>
                      <strong className="text-sm">Category</strong>
                    </th>
                    <th>
                      <strong className="text-sm">Vehicle</strong>
                    </th>

                    <th>
                      <strong className="text-sm">Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allPolyGon!==0 &&
                    allPolyGon?.map((item, key) => (
                      <tr key={item.id}>
                        <td>{item.GeofenceName}</td>
                        <td>Health</td>
                        <td>
                        <div className="row mt-2"><div className="col-sm-6">Bike</div>
                            <div className="col-sm-2">
                            {/* <Link
                            onClick={() => {
                              // removeVehicleFromGeo(val,item._id)
                            }}
                            href="#"
                            className="btn btn-danger shadow btn-xs sharp"
                          >
                            <i className="fa fa-trash"></i>
                          </Link> */}
                            </div>
                            </div>
                        </td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push("view-PolyLine", { item });
                                }}
                              >
                                View Geofence
                              </Dropdown.Item>
                              {/* <Dropdown.Item
                                onClick={() => {
                                    history.push("Update-PolyLine", { item });
                                }}
                              >
                                Update Geofence
                              </Dropdown.Item> */}
                              <Dropdown.Item
                                onClick={() => {
                                  let remVehicle = [];
                                  setShow(true);
                                  setDelStatus(false);
                                  setGeoId(item._id);
                                  if (item.GeofenceCategory === "Go_Taxi") {
                                    taxiVehicle.map((val) => {
                                      if (
                                        !item.GeofenceVehicle.includes(val.name)
                                      ) {
                                        remVehicle.push(val);
                                      }
                                    });
                                    setAddVehicleArr(remVehicle);
                                  }
                                  else
                                  if(item.GeofenceCategory === "Go_Movers"){
                                    moverVehicle.map((val) => {
                                        if (
                                          !item.GeofenceVehicle.includes(val.name)
                                        ) {
                                          remVehicle.push(val);
                                        }
                                      });
                                      setAddVehicleArr(remVehicle);
                                  }
                                  else
                                  if(item.GeofenceCategory === "Go_Food"){
                                    foodVehicle.map((val) => {
                                        if (
                                          !item.GeofenceVehicle.includes(val.name)
                                        ) {
                                          remVehicle.push(val);
                                        }
                                      });
                                      setAddVehicleArr(remVehicle);
                                  }
                                  else
                                  if(item.GeofenceCategory === "Go_Airport"){
                                    airportVehicle.map((val) => {
                                        if (
                                          !item.GeofenceVehicle.includes(val.name)
                                        ) {
                                          remVehicle.push(val);
                                        }
                                      });
                                      setAddVehicleArr(remVehicle);
                                  }
                                  else{
                                    healthVehicle.map((val) => {
                                        if (
                                          !item.GeofenceVehicle.includes(val.name)
                                        ) {
                                          remVehicle.push(val);
                                        }
                                      });
                                      setAddVehicleArr(remVehicle);
                                  }
                                }}
                              >
                                Add Vehicle
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setDelStatus(true);
                                  setGeoId(item._id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {allPolyGon.length === 0 && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCoupens
              </Alert>
            )}
          
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default AllPolyLines;
